import React, { Component } from "react";
import ListingPage from "../2/Controls/ListingPage";
import AddEditProductBrand from "./AddEditProductBrand";
import Input from "../2/Controls/Input";
import Window from "../2/Controls/Window";
import * as actionTypes from "../../actionTypes";

class BrandList extends Component {

  constructor(props) {
    super(props);

    this.state = {

      list: [],
      totalCount: 0,
      loading: false,

      page: 1,
      pageSize: 25,

      filter: {
        name: "",
        status: "active"
      },

      showAddBrand: false,
      selectedRow: null,

      showFilter: false,
      isFilterActive: false,

      showDeleteModal: false

    };

    this.listPageSettings = {

      Title: "Brand",

      Search: {
        showSearch: true,
        placeholder: "Search by brand",
        onSearch: this.onSearch,
        onFilterClick: () => this.setState({ showFilter: true }),
         onRefresh: this.onRefreshClick,
        isFilterActive: false
      },

      HeaderButtons: [

        {
          ButtonType: "Button",
          Type: "primary",
          Text: "New",
          Icon: "add",
          Action: "popup"
        }

      ],

      Columns: [

        {
          Name: "Brand",
          Type: "field",
          Columns: [
            { Column: "Brand" }
          ]
        },

        {
          Name: "Brand",
          Type: "field",
          ShowInMobile: true,
          Columns: [
            { Column: "Brand" }
          ]
        }

      ],

      RowButtons: [

        {
          ButtonType: "ImageButton",
          Type: "edit",
          Icon: "edit",
          Action: "popup"
        },

        {
          ButtonType: "ImageButton",
          Type: "delete",
          Icon: "delete",
          Action: "delete"
        }

      ],

      Sort: [
        {
          Column: "ActionOn",
          Order: "desc"
        }
      ]

    };

  }


  componentDidMount() {

    this.loadData();

  }

      onRefreshClick = () => {

  this.setState({

    filter: {
      name: "",
      status: "active",
    },

    isFilterActive: false,
    page: 1

  }, this.loadData);

};


  loadData = async () => {

    this.setState({ loading: true });

    const from = (this.state.page - 1) * this.state.pageSize;

    try {

      const res = await this.props.getProductBrands(

        from,
        this.state.pageSize,
        this.state.filter.status,
        this.state.filter.name

      );

      this.setState({

        list: res.searchResult || [],
        totalCount: res.totalCount || 0,
        loading: false

      });

    }

    catch (error) {

      console.error(error);

      this.setState({

        loading: false

      });

    }

  };


  onSearch = (searchText) => {

    this.setState({

      filter: {
        ...this.state.filter,
        name: searchText
      },

      page: 1

    }, this.loadData);

  };


  onNextClick = () => {

    const totalPages = Math.ceil(

      this.state.totalCount / this.state.pageSize

    );

    if (this.state.page < totalPages) {

      this.setState(

        prev => ({

          page: prev.page + 1

        }),

        this.loadData

      );

    }

  };


  onPreviousClick = () => {

    if (this.state.page > 1) {

      this.setState(

        prev => ({

          page: prev.page - 1

        }),

        this.loadData

      );

    }

  };


  onFirstClick = () => {

    this.setState({

      page: 1

    }, this.loadData);

  };


  onLastClick = () => {

    const totalPages = Math.ceil(

      this.state.totalCount / this.state.pageSize

    );

    this.setState({

      page: totalPages

    }, this.loadData);

  };


  onRecordsPerPageCountChange = (pageSize) => {

    this.setState({

      pageSize: Number(pageSize),
      page: 1

    }, this.loadData);

  };


  onHeaderButtonClicked = (btn) => {

    if (btn.Action === "popup") {

      this.setState({

        showAddBrand: true,
        selectedRow: null

      });

    }

  };


  onRowButtonClicked = (btn, row) => {

    if (btn.Action === "popup") {

      this.setState({

        showAddBrand: true,
        selectedRow: row

      });

    }

    if (btn.Action === "delete") {

      this.setState({

        showDeleteModal: true,
        selectedRow: row

      });

    }

  };


  deleteRecord = async () => {

    const success = await this.props.deleteProductBrand(

      this.state.selectedRow.key

    );

    if (success) {

      this.setState({

        showDeleteModal: false,
        selectedRow: null

      }, this.loadData);

    }

  };


  onApplyFilter = () => {

    this.setState({

      isFilterActive: true,
      page: 1,
      showFilter: false

    }, this.loadData);

  };


  onClearFilter = () => {

    this.setState({

      filter: {

        name: "",
        status: "active"

      },

      isFilterActive: false,
      page: 1,
      showFilter: false

    }, this.loadData);

  };


  onPostPopupSave = () => {

    this.setState({

      showAddBrand: false,
      selectedRow: null

    }, this.loadData);

  };


  onClosePopup = () => {

    this.setState({

      showAddBrand: false,
      selectedRow: null

    });

  };

  onPageChange = (page, pageSize) => {
  console.log("page",page);
  this.setState(
    { page, pageSize },
    () => {
      this.loadData();
    }
  );
};

  render() {

    return (

      <>

        <ListingPage
         {...this.props} 
           onPageChange={this.onPageChange}

          listPageSettings={{

            ...this.listPageSettings,

            Search: {

              ...this.listPageSettings.Search,

              isFilterActive: this.state.isFilterActive

            }

          }}

          list={this.state.list}

          loading={this.state.loading}

          totalItemsCount={this.state.totalCount}

          recordFrom={(this.state.page - 1) * this.state.pageSize}

          itemsCountPerPage={this.state.pageSize}

          onNextClick={this.onNextClick}

          onPreviousClick={this.onPreviousClick}

          onFirstClick={this.onFirstClick}

          onLastClick={this.onLastClick}

          onRecordsPerPageCountChange={this.onRecordsPerPageCountChange}

          onHeaderButtonClicked={this.onHeaderButtonClicked}

          onRowButtonClicked={this.onRowButtonClicked}

        />


        {this.state.showAddBrand && (

          <AddEditProductBrand

            {...this.props}

            productBrand={this.state.selectedRow}

            onSave={this.onPostPopupSave}

            onClose={this.onClosePopup}

          />

        )}


        {this.state.showFilter && (

          <Window

            header="Filter"

            size="small"

            slide={true}

            onClose={() =>

              this.setState({

                showFilter: false

              })

            }

            onButtonClick={(action) => {

              if (action.toLowerCase() === "apply") {

                this.onApplyFilter();

              }

              else {

                this.onClearFilter();

              }

            }}

            buttons={[

              {

                Type: "secondary",

                Text: "Clear",

                Align: "left"

              },

              {

                Type: "primary",

                Text: "Apply",

                Align: "right"

              }

            ]}

          >

            <Input

              type="text"

              label="Brand Name"

              value={this.state.filter.name}

              onChange={(value) =>

                this.setState({

                  filter: {

                    ...this.state.filter,

                    name: value

                  }

                })

              }

            />


            <Input

              type="select"

              label="Status"

              value={this.state.filter.status}

              onChange={(value) =>

                this.setState({

                  filter: {

                    ...this.state.filter,

                    status: value

                  }

                })

              }

            >

              <option value="active">

                Active

              </option>

              <option value="inActive">

                In Active

              </option>

              <option value="all">

                All

              </option>

            </Input>

          </Window>

        )}


        {this.state.showDeleteModal && (

          <Window

            header="Delete"

            size="medium"

            modal={true}

            onClose={() =>

              this.setState({

                showDeleteModal: false

              })

            }

            onButtonClick={(btn) => {

              if (btn.toLowerCase() === "yes") {

                this.deleteRecord();

              }

              else {

                this.setState({

                  showDeleteModal: false,
                  selectedRow: null

                });

              }

            }}

            buttons={[

              {

                Type: "secondary",

                Text: "No",

                Align: "left"

              },

              {

                Type: "primary",

                Text: "Yes",

                Align: "right"

              }

            ]}

          >

            Are you sure you want to delete this Brand?

          </Window>

        )}

      </>

    );

  }

}

export default BrandList;